import { yandexMap, ymapMarker } from 'vue-yandex-maps';

export default {
  components: { yandexMap, ymapMarker },
  data() {
    return {
      controls: ['zoomControl', 'fullscreenControl'],
      mapCenterCoords: [55.018803, 82.933952],
      defaultZoom: 3,
      clusterOptions: {
        1: {
          clusterDisableClickZoom: false,
          clusterOpenBalloonOnClick: false,
          clusterBalloonLayout: [
            '<ul class=list>',
            '{% for geoObject in properties.geoObjects %}',
            '<li><a href=# class="list_item">{{ geoObject.properties.balloonContentHeader|raw }}</a></li>',
            '{% endfor %}',
            '</ul>',
          ].join(''),
        },
      },
      mapSettings: {
        apiKey: 'a7aeb4aa-f3ec-4cc4-97b7-c0355d9b0af9',
        lang: 'ru_RU',
        coordorder: 'latlong',
        enterprise: false,
        version: '2.1',
      },
      markerIcon: {
        layout: 'default#imageWithContent',
        imageHref: '/static/pwaicons/apple-touch-icon.png',
        imageSize: [38, 38],
        imageOffset: [0, 0],
      },
    };
  },

  computed: {
    items() {
      return this.$store.getters['partners/getItems'];
    },
    groupItems() {
      const data = this.items.reduce((r, e) => {
        const group = e.city_name[0].toUpperCase();
        if (!r[group]) r[group] = { group, children: [e] };
        else r[group].children.push(e);
        return r;
      }, {});

      // since data at this point is an object, to get array of values
      // we use Object.values method
      return Object.values(data);
    },
  },

  created() {
    this.$store.dispatch('partners/GetList');
  },
};
